<template>
	<div :class="{ contactClickable: isHover }">
	<el-card :body-style="{ padding: '0px' }" :shadow="shadow" v-bind:class="[secondary ?  'small': '']" >

		<div class="card-info" style="min-height:120px;">
			<el-row >
				<el-container>

				 <!-- <el-aside style="width:50px">
			 		<vue-avatar v-bind:username=name :src="'/path/to/img'"></vue-avatar>
				 </el-aside> -->
				 <el-main class="contact-fiche-info">
				 	<el-row >
				 		<el-col>
							<PortausLink path="/contacts/" :id="contact.id" :label="name"></PortausLink>
				 		</el-col>
				 	</el-row>
				 	<el-row v-if="this.hasRole" >
				 		<el-col>
				 			<span class="secondary-text fs-14">{{contact.role.code}}</span>
				 		</el-col>
				 	</el-row>
				 	<el-row >
				 		<el-col>
							<Email :email="getEmail" :mailTo="true"></Email>
				 		</el-col>
				 	</el-row>
				 	<el-row >
				 		<el-col>
							<span class="secondary-text fs-14" v-if="getPhone">{{getPhone}}</span>
							<span class="secondary-text fs-14" v-else>{{ $t('common.notAvailable') }}</span>
							<span class="seconday-text fs-14" v-if="getPhoneExt!=null"> Ext.: {{getPhoneExt}}</span>
				 		</el-col>
				 	</el-row>
					<el-row v-if="isExternalAccountAPIModuleactive === true">
						<span class="secondary-text fs-14">
							<el-dropdown  @command="handleAccountCommand">
							<span class="el-dropdown-link secondary-text fs-14">
								<i v-if="hasWebAccount" class="mdi mdi-lock-check mr-5" />
								<i v-if="!hasWebAccount" class="mdi mdi-lock-off mr-5" />
								Accès Web<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :disabled="isWebAccountActive === true" command="createAccount"><i class="mdi mdi-lock-plus" />Créer un accès</el-dropdown-item>
								<el-dropdown-item :disabled="isWebAccountActive === false"  command="resetPassword"><i class="mdi mdi-lock-reset" />Réinitialiser le mot de passe</el-dropdown-item>
								<el-dropdown-item :disabled="isWebAccountActive === false"><i class="mdi mdi-lock-remove" />Retirer l'accès</el-dropdown-item>
							</el-dropdown-menu>
							</el-dropdown>
						</span>
					</el-row>
				 	<div v-if="showAddress">
					 	<el-row  v-bind:class="[secondary ? 'hide': '']">
					 		<el-col :span="1">
					 			<i class="mdi mdi-map-marker-outline"></i>
					 		</el-col>
					 		<el-col :span="23" style="padding-left:2px;">
					 			<div>
					 				<span class="client-info">{{contact.street}}</span><br>
					 				<span class="client-info">{{contact.city}}, {{contact.state_name}}</span><br>
					 				<span class="client-info">{{contact.country_name}} {{contact.postal_code}}</span>
					 			</div>
					 		</el-col>
					 	</el-row>
				 	</div>
				 </el-main>
				</el-container>
			</el-row>
			<el-row>
				<div style="z-index:1000">
					<el-button v-if="canRemove" style="float: right; padding: 3px 0;margin-left:10px;" type="text" @click="$emit('remove', index);">{{$t('common.Delete')}}</el-button>
					<el-button v-if="editable" style="float: right; padding: 3px 0;margin-left:10px;" type="text" @click="$emit('edit', index);">{{$t('common.Edit')}}</el-button>
				</div>
			</el-row>
		</div>
	</el-card>
</div>
</template>

<script>

import Email from '@/components/email'
import PortausLink from '@/components/portaus-link'
import accountAPI from '@/services/API/account'
import { mapGetters } from 'vuex';
export default {
	name: 'ContactCard',
	props : {
		customerId: {
			type: Number,
		},
		contact : {
			type : Object,
		},
		secondary : {
				type : Boolean
		},
		isIndividual : {
			type : Boolean
		},
		removable : {
			type : Boolean,
		},
		index:{
			type : Number
		},
		editable : {
			type : Boolean
		},
		shadow : {
			type : String,
		},
		showWebAccess: {
			type: Boolean,
			default: false
		},
	},
	components : {
		Email,
		PortausLink
	},
	computed : {
		hasWebAccount () {
			return this.contact.account != null;
		},
		isWebAccountActive () {
			return this.hasWebAccount && _.get(this.contact, 'account.active');
		},
		isHover(){
			if(this.editable){
				return "hover";
			}
		},
		isHover(){
			return this.shadow=='hover';
		},
		canRemove(){
			if(this.removable==null || this.removable==false){
				return false
			}else {
				return true;
			}
		},
		showAddress(){
			return this.isIndividual && (this.contact.street!=null && this.contact.street != "");
		},
		name(){
			if((this.contact.first_name==null || this.contact.first_name==='') && (this.contact.last_name==null || this.contact.last_name==='')){
				return "Unnamed contact"
			}
			return this.contact.first_name + " " + this.contact.last_name;
		},
		hasRole(){
			return (this.contact.role!=null && this.contact.role.code!=null);
		},
		getPhone(){
			if(this.isIndividual){
				return (this.contact.phone!=null&&this.contact.phone!="")?this.contact.phone:null;
			}
			return (this.contact.work_phone!=null&&this.contact.work_phone!="")?this.contact.work_phone:null;

		},
		getPhoneExt(){
			if(this.isIndividual){
				return (this.contact.phone_ext!=null&&this.contact.phone_ext!="")?this.contact.phone_ext:null;
			}
			return (this.contact.work_phone_ext!=null&&this.contact.work_phone_ext!="")?this.contact.work_phone_ext:null;

		},
		getEmail(){
			if(this.isIndividual){
				return (this.contact.email!=null&&this.contact.email!="")?this.contact.email:null;
			}
			return (this.contact.work_email!=null&&this.contact.work_email!="")?this.contact.work_email:null;
		},
		...mapGetters(['isExternalAccountAPIModuleactive'])

	},
	methods: {
		handleAccountCommand (command) {
			if (command === 'resetPassword') {
				this.resetPassword();
			} else if (command === 'createAccount') {
				this.createAccount();
			}
		},
		createAccount (){
			const postInfo = {
				email: this.contact.email,
				user: {
					id: this.contact.id,
				},
				customer: {
					id: this.customerId,
				}
			}
			return accountAPI.createAccount(postInfo)
				.then((account) => {
					this.$message.success(`L'accès web a été créé avec succès. Un courriel a été envoyé à l'utilisateur.`);
					this.$emit('onAccountChange', account);
				}).catch(() => {
					this.$message.error(`Une erreur est survenue. Veuillez réessayer plus tard.`);
				})
		},
		resetPassword () {
			return accountAPI.resetPassword(this.contact.account.id)
				.then(() => {
					this.$message.success(`Un courriel de réinitialisation a été envoyé à l'utilisateur.`);
				}).catch(() => {
					this.$message.error(`Une erreur est survenue. Veuillez réessayer plus tard.`);
				})
		},
		openContact(){
			var index = '/contacts/' + this.contact.id;
			this.$router.push(index)
			this.$emit('push-page', {page:index})
		}
	}

}
</script>

<style lang="scss" scoped>

.small{
	// font-size:10pt;
	// height:120px;
}
.hide{
	display:none;
}
.contact-fiche-info{
	padding-left:10px!important;
}
.client-info{
 	margin:5px;
 }

 .no-info{
	 font-size:12px;
 }
.client-name{
  	font-size:1.5 em;
  	color:#4a596a;
  }

.card-info{
	margin:20px;
	color:#a9aaad;
	margin-bottom:10px;
	//padding-right:120px;
}
.el-row{
	margin-bottom:5px;
}

.remove-control{
	position: absolute;
    top: 10px;
    float: right;
    right: 20px;
	color:#9AA2AC;

}
.remove-control:hover{
	cursor:pointer;
	color:#4a596a;
}

.edit-control{
	position: absolute;
    top: 10px;
    float: right;
    right: 40px;
	color:#9AA2AC;

}
.edit-control:hover{
	cursor:pointer;
	color:#4a596a;
}

.el-main {
	padding:0px;
}

.contactClickable{
	cursor:pointer;
}



@media (max-width: 768px) {

}
</style>
